import _ from 'underscore';

export const valueUnion = <T>(
  getKey: (value: T) => string | number,
  ...colls: T[][]
): T[] => {
  const collection: Record<string, T> = {};
  _.flatten(colls).forEach(function (x) {
    const key = getKey(x).toString();
    if (collection[key] && _.isObject(collection[key])) {
      return (collection[key] = _.extend({}, collection[key], x));
    } else {
      return (collection[key] = x);
    }
  });
  return (() => {
    const result = [];
    for (const key of Object.keys(collection || {})) {
      const value = collection[key];
      result.push(value);
    }
    return result;
  })();
};
